/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Format_LabelInputs */

const en_dialogue_list_export_format_label = /** @type {(inputs: Dialogue_List_Export_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const fr_dialogue_list_export_format_label = /** @type {(inputs: Dialogue_List_Export_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const de_dialogue_list_export_format_label = /** @type {(inputs: Dialogue_List_Export_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const it_dialogue_list_export_format_label = /** @type {(inputs: Dialogue_List_Export_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

const ru_dialogue_list_export_format_label = /** @type {(inputs: Dialogue_List_Export_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Формат`)
};

const es_dialogue_list_export_format_label = /** @type {(inputs: Dialogue_List_Export_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

const zh_cn2_dialogue_list_export_format_label = /** @type {(inputs: Dialogue_List_Export_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`格式`)
};

const ja_dialogue_list_export_format_label = /** @type {(inputs: Dialogue_List_Export_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`形式`)
};

const hi_dialogue_list_export_format_label = /** @type {(inputs: Dialogue_List_Export_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारूप`)
};

const pt_pt2_dialogue_list_export_format_label = /** @type {(inputs: Dialogue_List_Export_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatar`)
};

/**
* | output |
* | --- |
* | "Format" |
*
* @param {Dialogue_List_Export_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_format_label = /** @type {((inputs?: Dialogue_List_Export_Format_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Format_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_format_label(inputs)
	if (locale === "de") return de_dialogue_list_export_format_label(inputs)
	if (locale === "it") return it_dialogue_list_export_format_label(inputs)
	if (locale === "ru") return ru_dialogue_list_export_format_label(inputs)
	if (locale === "es") return es_dialogue_list_export_format_label(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_format_label(inputs)
	if (locale === "ja") return ja_dialogue_list_export_format_label(inputs)
	if (locale === "hi") return hi_dialogue_list_export_format_label(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_format_label(inputs)
	return en_dialogue_list_export_format_label(inputs)
});